export default "__VITE_ASSET__D8ztXy7___"